// src/pages/AdApplication.jsx
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import AdsModal from "../components/AdsModal";
import { Button } from "@material-ui/core";
import { SnackbarContext } from "../context/SnackbarContext";
import { useAPI } from "../context/ApiContext";
import { useTranslation } from "react-i18next";

const AdApplication = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { newSnack } = useContext(SnackbarContext);
  const { isAuthenticated, allowAd } = useAPI();

  const [isShowAdsModal, setShowAdsModal] = useState(false);

  const handleAdsClick = () => {
    if (!isAuthenticated) {
      newSnack("error", t("AdApplication1") || "出稿にはログインが必要です");
      history.push("/login");
      return;
    }
    setShowAdsModal(true);
  };
  const handleModalClose = () => setShowAdsModal(false);

  // Stripe success 戻りの処理
  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const success = q.get("success");
    const sessionId = q.get("session_id");
    const signedAdsId = q.get("indexAds");
    if (success === "true" && sessionId && signedAdsId) {
      (async () => {
        try {
          await allowAd(signedAdsId); // 管理者のみ成功
          newSnack("success", t("AdsApproved") || "決済完了：広告を公開しました");
        } catch (e) {
          // 一般ユーザーはここで 403 になる想定
          newSnack("success", t("AdsPaid") || "決済が完了しました。審査後に公開されます。");
        } finally {
          // クエリ掃除
          history.replace("/adapplication");
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <Header />
      <Leftnav />

      <div className="main-content bg-lightblue theme-dark-bg right-chat-active">
        <AdsModal isVisible={isShowAdsModal} handleClose={handleModalClose} />

        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                  <Link to="/settings" className="d-inline-block mt-2">
                    <i className="ti-arrow-left font-sm text-white"></i>
                  </Link>
                  <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                    {t("AdApplication2") || "広告出稿"}
                  </h4>
                </div>

                {/* ヒーロー */}
                <div
                  className="card mt-2 w-100 border-0 p-0 rounded-3 overflow-hidden bg-image-contain bg-image-center"
                  style={{ backgroundImage: `url("assets/images/background_advertisement.jpg")` }}
                >
                  <div className="card-body p-md-5 p-4 text-center" style={{ backgroundColor: "rgba(71,120,79,0.8)" }}>
                    <h2 className="fw-700 display2-size text-white display2-md-size lh-2">
                      {t("AdApplication3") || "あなたの情報を、いちばん届く場所へ。"}
                    </h2>
                    <p className="font-xsss ps-lg-5 pe-lg-5 lh-28 text-grey-200">
                      {t("AdApplication4") || "nicelinks のタイムラインにシンプルで効果的な広告を掲載できます。"}
                    </p>
                  </div>
                </div>

                {/* 仕様の説明（そのまま画像を活用） */}
                <div className="card w-100 border-0 shadow-none bg-transparent mt-5">
                  <div className="card shadow-xss">
                    <div className="card-header"><h5 className="fw-600 pt-2 pb-2 mb-0">{t("AdApplication5") || "テキスト広告"}</h5></div>
                    <div className="card-body">
                      <p>{t("AdApplication6") || "本文だけで訴求する、軽量な広告です。"}</p>
                      <div className="col-xl-8 col-xxl-9 col-lg-8">
                        <img src="assets/images/ad_2.png" alt="" className="rounded-3 img-fluid w-100" />
                      </div>
                    </div>
                  </div>

                  <div className="card shadow-xss mt-3">
                    <div className="card-header"><h5 className="fw-600 pt-2 pb-2 mb-0">{t("AdApplication7") || "画像広告"}</h5></div>
                    <div className="card-body">
                      <p>{t("AdApplication8") || "画像で直感的に伝えられます。URLも設定可能。"}</p>
                      <div className="col-xl-8 col-xxl-9 col-lg-8">
                        <img src="assets/images/ad_5.png" alt="" className="rounded-3 img-fluid w-100" />
                      </div>
                    </div>
                  </div>

                  <div className="card shadow-xss mt-3">
                    <div className="card-header"><h5 className="fw-600 pt-2 pb-2 mb-0">{t("AdApplication11") || "配信ターゲット"}</h5></div>
                    <div className="card-body">
                      <p>{t("AdApplication12") || "回数に応じてご購入いただけます。"}</p>
                      <div className="col-xl-8 col-xxl-9 col-lg-8">
                        <img src="assets/images/ad_3.png" alt="" className="rounded-3 img-fluid w-100" />
                      </div>
                    </div>
                  </div>
                </div>

                {/* CTA */}
                <div className="card-body p-lg-5 p-4 w-100 border-0">
                  <div className="row justify-content-center mb-4">
                    <div className="col-lg-12 text-center">
                      <Button
                        className="bg-current text-center text-white font-xsss fw-600 p-3 w175 rounded-3 ms-1 me-1 mt-3"
                        variant="contained"
                        onClick={handleAdsClick}
                      >
                        {t("AdApplication13") || "広告を出す"}
                      </Button>
                      {/* <Link to="/pagesearch">
                        <Button
                          className="bg-current text-center text-white font-xsss fw-600 p-3 ms-1 me-1 w175 rounded-3 mt-3"
                          variant="contained"
                        >
                          {t("AdApplication14") || "ページを探す"}
                        </Button>
                      </Link> */}
                    </div>
                  </div>
                </div>
              </div>{/* /card */}
            </div>
          </div>
        </div>
      </div>

      <Appfooter />
    </Fragment>
  );
};

export default AdApplication;
